import * as actionTypes from './actionTypes';

export const openDialog=()=>{
    return { type: actionTypes.ACTION_CONFIRM_DIALOG_OPEN };
}

export const closeDialog=()=>{
    return { type: actionTypes.ACTION_CONFIRM_DIALOG_CLOSE };
}

export const openDialog2=()=>{
    return { type: actionTypes.ACTION_CONFIRM_DIALOG2_OPEN };
}

export const closeDialog2=()=>{
    return { type: actionTypes.ACTION_CONFIRM_DIALOG2_CLOSE };
}


// WEBPACK FOOTER //
// ./src/redux/actConfDialog/actions.js